import { UserNoPasswordNoRelations } from './UserNoPasswordNoRelations';

export type SystemLog = {
  id: number;
  user_id: number | null;
  user: UserNoPasswordNoRelations | null;
  category: number;
  log: string;
  timestamp: string;
};

export enum LogCategory {
  Login,
  Logout,
  Users,
  Dishes,
  Instruments,
  Snapshots,
  Recording,
  Alarms,
  System,
}
